<template>
  <el-dialog
    title="添加贡献值"
    :visible.sync="dialogVisible"
    customClass="customWidth"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="mini"
    >
      <el-form-item
        prop="legal2"
        label="代理名称"
      >
        {{userName}}
      </el-form-item>
      <el-form-item
        prop="userName"
        label="原贡献值"
      >
        {{sjName}}
      </el-form-item>
      <el-form-item
        prop="accountType"
        label="类型"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                v-model="form.accountType"
                placeholder="请选择"
                class="search-input"
        >
          <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
        <el-form-item label="贡献值" prop="amount"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form.amount"></el-input>
        </el-form-item>





    <el-form-item>
      <el-button
              type="primary"
              :loading="loading"
              @click="saveUser"
      >保存</el-button>
      <el-button @click="close">取消</el-button>
    </el-form-item>
    </el-form>
  </el-dialog>

</template>
<style>
  .customWidth{
    width:80%;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js';
export default {
  name: "twoagentyEditForm",
  props: {
      oneagent: Object,
    value: Boolean
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
        userName:"",
        sjName:"",
      form: {
          accountType:"",
          amount:""
      },
        typeOptions: [ {
            value: "1",
            label: "加贡献值"
        },{
            value: "0",
            label: "减贡献值"
        }]
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {

    dialogOpen() {
      this.$refs.form.resetFields();
      if (this.oneagent.userId) {

          this.userName = this.oneagent.agentname;
          this.sjName=this.oneagent.red_amt;
      } else {
        this.form = {};
      }

    },
      saveUser() {
          this.$refs["form"].validate(valid => {
              if (valid) {
                  if (this.oneagent.userId) {
                      this.loading = true;
                      agentService.saveRedAmt({ ...this.form,userId:this.oneagent.userId ,agentid:this.oneagent.agentid})
                          .then(data => {
                              this.loading = false;
                              this.dialogVisible = false;
                              this.$emit("submit");
                          });
                  }
              } else {
                  return false;
              }
          });
      },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

